import React, {
  useState
} from 'react';
import { historyPropType } from '~/config/routerPropTypes';
import { createCoupon } from '~/config/routes';
import Request from '~/providers/Request';
import CouponRecord from '~/records/CouponRecord';
import Form from './Form';
import { toast } from 'react-toastify';

function NewRecord({history}){
  const [record, setRecord] = useState(new CouponRecord());
  const [loading, setLoading] = useState(false);

  async function onSubmit (saveAndContinue){
    const data = await record.toParams();
    if ( 
      !data.data.attributes.discount_type || 
      !data.data.attributes.discount_value || 
      !data.data.attributes.expires_at || 
      !data.data.attributes.name || 
      !data.data.attributes.promotion_type || 
      !data.data.attributes.start_date || 
      !data.data.attributes.user_limit
    ) {
      toast.error('Preencha todos os campos obrigatórios!');
      return;
    }
    
    if(data.data.attributes.discount_type === 2 && data.data.attributes.discount_value > 100){
      toast.error('Desconto não pode ser maior que 100%');
      return;
    }

    if(data.data.attributes.start_date === data.data.attributes.expires_at){
      toast.error('A data de início e de expiração não podem ser iguais');
      return;
    }

    if ( 
      data.data.attributes.name.length > 50 || 
      data.data.attributes.promotion_type.length > 50 ||  
      data.data.attributes.user_limit > 250000000
    ) {
      toast.error('Limite Excedido! Verifique os campos e tente novamente.');
      return;
    }

    setLoading(true);

    await Request.post('/admin/coupon', data, {}, { controller: 'coupon' })
      .then(() => {
        setLoading(false);
        toast.success('Cupom criado com sucesso!');
        if(saveAndContinue){
          history.push(createCoupon.spec);
        } else {
          history.push('/coupon');
        }
      })
      .catch(e => {
        toast.error(`Falha ao criar cupom: ${e.message}`);
        console.error(e);
        setLoading(false);
      });
  }

  const handleChange = (attrs) => {
    setRecord( record.updateAttributes(attrs) );
  };

  return(
    <Form
      onSubmit={onSubmit}
      record={record}
      handleChange={handleChange}
      loading={loading}
      setRecord={setRecord}
    />
  );
}

NewRecord.propTypes={
  history: historyPropType,
};

export default NewRecord;
